var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocationEvent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 7.27273,
    fill: "#F6F8F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9092 21.9102H20.091",
    stroke: "#000229",
    strokeWidth: 0.909091,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0003 16.4557C17.0045 16.4557 17.8185 15.6417 17.8185 14.6375C17.8185 13.6334 17.0045 12.8193 16.0003 12.8193C14.9962 12.8193 14.1821 13.6334 14.1821 14.6375C14.1821 15.6417 14.9962 16.4557 16.0003 16.4557Z",
    stroke: "#000229",
    strokeWidth: 0.909091,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5455 14.6373C20.5455 18.7282 16 21.91 16 21.91C16 21.91 11.4546 18.7282 11.4546 14.6373C11.4546 13.4317 11.9335 12.2756 12.7859 11.4231C13.6384 10.5707 14.7945 10.0918 16 10.0918C17.2056 10.0918 18.3617 10.5707 19.2142 11.4231C20.0666 12.2756 20.5455 13.4317 20.5455 14.6373V14.6373Z",
    stroke: "#000229",
    strokeWidth: 0.909091,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationEvent);
export default __webpack_public_path__ + "static/media/location-event.c91e71c286482c56c047625322fc5f3c.svg";
export { ForwardRef as ReactComponent };